import { WithDefault, AdpData } from '../types';
import {
  END_USE_CODE_DROPDOWN_NAME,
  ORDER_TYPE_RADIO_NAME,
  SELECT_CUSTOMER_FORM_ID
} from '../constants/constants';
import { YES, NO } from '../../../constants/common';

export const getDefaultValue = <T extends WithDefault>(
  data: Array<T>
): T | undefined => {
  return data?.find((e) => e.isDefault);
};

export const sortLabelName = (a, b) => a.label?.localeCompare(b.label);

export const getFormContent = (
  isLoginAction: boolean,
  skipThisStep: boolean
) => {
  let formContent = '';
  if (isLoginAction) {
    formContent = skipThisStep ? YES : NO;
  }
  return formContent;
};

export const getGaEvent = (
  isLoginAction: boolean,
  skipThisStep: boolean,
  status: string
) => {
  const formName = SELECT_CUSTOMER_FORM_ID;
  const formContent = getFormContent(isLoginAction, skipThisStep);
  return { formName, formContent, formStatus: status };
};

export const payloadBuilder = ({
  formData,
  selectedCustomerNumber,
  endUseCodeList,
  selectedStoreLocation,
  selectedDealer,
  isLoginAction = false,
  skipADP = false,
  dealerUserValue,
  dealerUserCustomerName,
  isDealerUser
}: AdpData) => {
  const endUseCode = endUseCodeList?.find(
    (endUseCode) => endUseCode?.label === formData[END_USE_CODE_DROPDOWN_NAME]
  );

  return {
    customerNumber: isDealerUser
      ? dealerUserCustomerName.value
      : selectedCustomerNumber?.value,
    customerName: isDealerUser
      ? dealerUserCustomerName.label
      : selectedCustomerNumber?.label,
    orderType: formData[ORDER_TYPE_RADIO_NAME],
    endUseCode: endUseCode?.value ?? null,
    skipADP,
    isLoginAction,
    storeLocationCode: selectedStoreLocation?.value ?? null,
    equipmentMakeModel: null,
    equipmentSerialNumber: null,
    selectedDealer: {
      id: isDealerUser ? dealerUserValue.value : selectedDealer.id
    }
  };
};

export const getSelectedDealer = ({ associations, currentDealerValue }) => {
  //associations
  const selectedDealer = associations?.find((association) => {
    if (currentDealerValue) {
      return (
        association.dealerName === currentDealerValue ||
        association.id === currentDealerValue
      );
    }
    return association.isDefault;
  });

  return selectedDealer || associations?.[0];
};

export const getSelectedCustomerNumber = ({
  customerNumberList,
  currentCustomerNumberValue
}) => {
  //selectedCustomerNumber
  const selectedCustomerNumber = customerNumberList?.find((customerNumber) => {
    if (currentCustomerNumberValue) {
      return customerNumber.label === currentCustomerNumberValue;
    }
    return customerNumber.default;
  });

  return selectedCustomerNumber;
};

export const getAdpModalState = (response) => {
  let openAdpModal = false;
  const isSuccessRedirect =
    !!response?.successRedirect && response?.noDealerInfo !== 'Y';
  const findYourDealer =
    response?.redirectToFindYourDealer || response?.noDealerInfo === 'Y';

  if (findYourDealer || (isSuccessRedirect && !response?.noUCID)) {
    openAdpModal = true;
  }
  return openAdpModal;
};
